var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.perPage),function(row){return _c('b-tr',{key:row},_vm._l((_vm.columnsCount),function(col){return _c('b-td',{key:col},[_c('b-skeleton',{attrs:{"width":`${Math.round(Math.random() * 50) + 50}%`}})],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }